/* pd-timeline —— 移动端 tab 切换。
   桌面端 (>=768px) tab 行 display:none，此脚本只驱动 <768px 的「点 tab 切换展开卡」。
   每个 <pd-timeline-tabs> 通过 closest('.pd-timeline') scoped 到本 section，多实例互不干扰。 */
(function () {
  if (customElements.get('pd-timeline-tabs')) return;

  class PdTimelineTabs extends HTMLElement {
    connectedCallback() {
      var root = this.closest('.pd-timeline');
      if (!root) return;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.pd-timeline__tab'));
      this.panels = Array.prototype.slice.call(root.querySelectorAll('.pd-timeline__stage'));
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { self.select(tab); });
      });
    }

    select(tab) {
      var idx = tab.getAttribute('data-pd-tl-tab');
      this.tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach(function (p) {
        p.classList.toggle('is-selected', p.getAttribute('data-pd-tl-panel') === idx);
      });
    }
  }

  customElements.define('pd-timeline-tabs', PdTimelineTabs);
})();
